export default "__VITE_ASSET__30dfb991__"